import { Component, OnInit } from "@angular/core";
import {
  Router,
  ActivatedRoute,
} from "@angular/router";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { UserService } from "../../services/user.service";
import { ClientService } from "../../services/client.service";
import { first } from "rxjs/operators";
import { LoaderService } from "src/app/services/loader.service";
import { Intercom } from '@supy-io/ngx-intercom';
import { DeviceDetectorService } from "ngx-device-detector";
import { AppComponent } from "src/app/app.component";
import { RegisterUserData } from "../models/two-factor-auth.model";
import * as amplitude from '@amplitude/analytics-browser';;
import { AmplitudeService } from "src/app/shared/services/amplitude.service";
import { MatDialog } from "@angular/material/dialog";
import { DeviceRestrictionDialogComponent } from "../device-restriction-dialog/device-restriction-dialog.component";
import { EnvService } from "src/app/services/environment.service";
import { PosthogService } from "src/app/services/posthog.service";
import { Action } from "rxjs/internal/scheduler/Action";
import { DpopService } from "src/app/services/dpop.service";
@Component({
  selector: "app-signin",
  templateUrl: "./signin.component.html",
  styleUrls: ["./signin.component.scss"],
})
export class SigninComponent implements OnInit {
  loginForm: UntypedFormGroup;
  submitted = false;
  returnUrl: string;
  hide = true;
  isLoading = false;
  showLogError: string;
  deviceInfo: any;
  locked: boolean = false;
  lockedwarning: boolean = false;
  failedtimes;
  isMobile: boolean = false;
  isTablet: boolean = false;
  deviceDetails: any;
  // ssoLoginEndpoint = environment.ssoLoginUrl;
  constructor(
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private CS: ClientService,
    private userService: UserService,
    public loaderService: LoaderService,
    private intercom: Intercom,
    public AP: AppComponent,
    private deviceService: DeviceDetectorService,
    private amplitudeService: AmplitudeService,
    private dialog: MatDialog,
    public environment: EnvService,
    private posthogService: PosthogService,
    private dpopService: DpopService
  ) {
    this.deviceInfo = this.deviceService.getDeviceInfo();
    this.isMobile = this.deviceService.isMobile();
    this.isTablet = this.deviceService.isTablet();
    // const isDesktopDevice = this.deviceService.isDesktop();
    this.amplitudeService.setUpAmplitudeOptions();
  }
  ngOnInit() {
    this.isLogggedIn();
    this.loginForm = this.formBuilder.group({
      username: ["", [Validators.required, Validators.email]],
      password: ["", [Validators.required]],
    });
    this.returnUrl = this.route.snapshot.queryParams["returnUrl"] || "/";
    this.intercom.boot({
      app_id: "pjk6ouyh",
      // Supports all optional configuration.
      custom_launcher_selector: '#intercom'
    });
  }
  get f() {
    return this.loginForm.controls;
  }
  async onSubmit() {
    this.isLoading = true;
    this.submitted = true;
    this.showLogError = '';
    if (this.loginForm.invalid) {
      this.isLoading = false;
      return;
    } else {
      this.deviceDetails = this.isMobile || this.isTablet ? `Mobile-${this.deviceInfo.browser}` : `${this.deviceInfo.os_version}-${this.deviceInfo.browser}`;
      this.userService.login(this.loginForm.value, false, this.deviceDetails).pipe(first()).subscribe((data) => {
        if (data.goAudits2) {
          localStorage.setItem('goAudits2', 'true');
          this.loginToPortal2(this.loginForm.get("username").value.trim(), this.loginForm.get("password").value.trim());
          return false;
        }

        localStorage.setItem('currentDeviceId', data.devid);
        localStorage.setItem('gp_flag', data.gp_flag);
        this.getDevicesDetails(data),
          this.posthogService.captureEvent("user landed on home page successfully", { Feature: "signin", Action: "home page" });
      },
        (error) => {
          this.isLoading = false;

          // Handle different error types
          if (typeof error === 'string') {
            // Error message from interceptor or service (includes CORS errors for signin)
            if (error == "locked") {
              this.locked = true;
              this.showLogError = '';
            } else {
              this.locked = false;
              this.showLogError = error;
            }
          } else if (error?.error) {
            // HTTP Error Response object
            if (error.error === 'Internet is required.') {
              this.showLogError = 'No Internet Connection\nPlease check your network settings and try again.';
            } else if (typeof error.error === 'string') {
              this.showLogError = error.error;
            } else if (error.error?.errorMessage) {
              this.showLogError = error.error.errorMessage;
            } else {
              this.showLogError = 'An unexpected error occurred. Please try again.';
            }
          } else {
            // Fallback for unknown error types
            this.showLogError = 'An unexpected error occurred. Please try again.';
          }

          /* this.loginForm.get('username').patchValue('');
                      this.loginForm.get('password').patchValue(''); */
          this.router.navigate(["/authentication/signin"]);
          this.posthogService.captureEvent("user landed on home page failed", { Feature: "signin", Action: "home page" });
        }
      );
    }
  }

  getDevicesDetails(data) {
    this.userService.getDeviceDetails(data.uid).subscribe((res: any) => {
      if (res?.deviceList?.length > 0) {
        const currentDevice = res?.deviceList?.reduce((a, b) => a.date > b.date ? a : b)
        localStorage.setItem('currentDevice', JSON.stringify(currentDevice));
      }
      localStorage.setItem('allow_Signin', res?.allow_Signin.toString());
      if (res.allow_Signin && data?.devid !== 'unsuccessful_login_webapp') {
        this.userService.setHasDevicedetails(true);
        this.loginResponseOperations(data)
      } else {
        res.deviceList = res?.deviceList?.filter(device => device?.id != data?.devid)
        this.checkLoggedIndevices(res, data)
      }
    })
  }

  loginResponseOperations(data) {
    amplitude.setUserId(data.uid);
    localStorage.setItem('isIncidentEnabled', data.incident_enabled || '0');
    localStorage.setItem('isNearMissEnabled', data.nearmiss_enabled || '0');
    localStorage.setItem('investigatorenabled', data.incident_investigator);
    localStorage.setItem('admin_level', data.admin_level.toString())
    if (data.lockout_user) {
      if (data.pass_fail_count > data.lockout_count) {
        localStorage.clear();
        this.isLoading = false;
        this.submitted = false;
        this.locked = true;
        return false;
      } else {
        this.locked = false;
      }
    }
    amplitude.setGroup('company', data.guid);
    const obj = {
      spec_char_allowed: data.spec_char_allowed,
      expiry_required: data.expiry_required,
      expiry_months: data.expiry_months,
      password_modified: data.password_modified,
      password_policy: data.password_policy,
      strictPasswordPolicy: data.strict_password_policy,
      firstName: data.fullname
        ? data.fullname.substr(0, data.fullname.indexOf(" "))
        : null,
      lastName: data.fullname
        ? data.fullname.substr(
          data.fullname.indexOf(" "),
          data.fullname.length - 1
        )
        : null,
      userId: data.user_name,
      characterCount: data.character_count,
    };
    localStorage.setItem("password_policy", JSON.stringify(obj));

    if (data.uid) {
      amplitude.setUserId(data.uid);
      amplitude.setGroup('company', data.guid);
      // let cstore_status = "";
      // if (data.license_type == "TRIAL" && data.is_cstore) {
      //   cstore_status = "notpaid";
      // } else if (data.license_type == "SUBSCRIBE" && data.is_cstore) {
      //   cstore_status = "paid";
      // } else {
      //   cstore_status = "na";
      // }
      this.intercom.boot({
        // Supports all optional configuration.
        app_id: "pjk6ouyh",
        email: this.loginForm.value.username,
        user_id: data.uid,
        // is_cstore: data.is_cstore,
        // cstore_status: cstore_status,
        // plan_type: data.subscription_model,
        // trial_days: data.days_remaining,
        // next_renewal_in: data.days_remaining,
        custom_launcher_selector: '#intercom'
      });

      this.intercom.trackEvent("login", {
        email: this.loginForm.value.username,
        user_id: data.uid,
      });
      const registeredData: RegisterUserData = {
        user_name: this.loginForm.get("username").value.trim(),
        usr_pwd: this.loginForm.get("password").value.trim(),
        first_name: data.first_name,
        last_name: data.last_name,
        using2fa: data.using2fa,
        logo: data.logo,
        uid: data.uid,
        guid: data.guid,
        strictPasswordPolicy: data.strict_password_policy,
        isSignUp: false,
        hasPortalAccess: data.portalAccess,
        hasAnalyticsAccess: data.analyticsAccess,
        qrRegistered: data.qr_registered,
        isMFA: data.is_mfa,
        email_verified: data?.email_verified
      };
      if (!data?.email_verified) {
        this.userService.setRegisterUserData(registeredData);
        this.router.navigate(["/authentication/verify-otp"]);
      }
      else {
        if (data.using2fa || data.is_mfa) {
          const registeredData: RegisterUserData = {
            user_name: this.loginForm.get("username").value.trim(),
            usr_pwd: this.loginForm.get("password").value.trim(),
            first_name: data.first_name,
            last_name: data.last_name,
            using2fa: data.using2fa,
            logo: data.logo,
            uid: data.uid,
            guid: data.guid,
            strictPasswordPolicy: data.strict_password_policy,
            isSignUp: false,
            hasPortalAccess: data.portalAccess,
            hasAnalyticsAccess: data.analyticsAccess,
            qrRegistered: data.qr_registered,
            isMFA: data.is_mfa,
            email_verified: data?.email_verified
          };
          this.userService.setRegisterUserData(registeredData);
          this.router.navigate(["/authentication/otp-confirmation"]);
        } else {
          this.isLoading = false;

          if (data.license_type == "TRIAL" && data.is_cstore) {
            this.router.navigate(["/account"]);
          } else {
            // Redirect to home if either incident or near miss is enabled
            if (data.incident_enabled || data.nearmiss_enabled) {
              this.router.navigate(["/home"]);
            } else {
              this.router.navigate(["/audits"]);
            }
          }
        }
      }
    }
  }
  // Logs into the 2.0 portal (gd-portal-ui) and stores its session the same way it does,
  // so opening the portal in a new tab lands the user straight on its dashboard.
  private async loginToPortal2(username: string, password: string): Promise<void> {
    try {
      await this.dpopService.initDpopKey();
      const publicKey = this.dpopService.getDpopPublicKey();

      const response = await fetch(`${this.environment.goaudits2AuthApiUrl}/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ username, password, publicKey }),
      });

      if (!response.ok) {
        console.error('2.0 portal login failed', response.status);
        return;
      }

      const responseBody = await response.json();
      const sessionData = responseBody.data || responseBody;

      const bootstrapPayload = {
        tenantId: sessionData.tenantId || response.headers.get('x-tenant-id') || response.headers.get('X-Tenant-Id'),
        accountId: sessionData.accountId || response.headers.get('x-account-id') || response.headers.get('X-Account-Id'),
        userId: sessionData.userId || username,
        schemaName: sessionData.schemaName || response.headers.get('x-schema-name') || response.headers.get('X-Schema-Name') || 'paid',
        tier: sessionData.tier || 'PAID',
        email: username,
        name: sessionData.name || sessionData.fullName || username,
      };
      const encodedBootstrap = btoa(unescape(encodeURIComponent(JSON.stringify(bootstrapPayload))));
      window.open(`${this.environment.goaudits2Url}#/dashboard?bootstrap=${encodedBootstrap}`, '_self');
    } catch (error) {
      console.error('Error logging into 2.0 portal', error);
    }
  }

  logout() {
    this.userService.signOutOfApp();
    //location.reload();
  }

  checkLoggedIndevices(deviceRes, data) {
    this.isLoading = false;
    this.submitted = false;
    const reqData = {
      deviceDetails: deviceRes,
      guid: data.guid,
      uid: data.uid,
      signInData: data,
      deviceName: this.deviceDetails
    }
    let width = 'auto';
    if (window.innerWidth > 1024) {
      width = '40%';
    } else if (window.innerWidth > 600) {
      width = '80%';
    }
    const dialogRef = this.dialog.open(DeviceRestrictionDialogComponent, {
      width: width,
      disableClose: true,
      data: reqData,
      panelClass: 'location_popup'
    })
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.userService.setHasDevicedetails(true);
        this.loginResponseOperations(data)
      }
    })
  }

  checkIfUserLoggedIn() {
    const user = JSON.parse(localStorage.getItem("user"));

    if (user === null) {
      this.reloadURL();
    } else {
      //  this.router.navigate(["/authentication/signin"]);
    }
  }
  reloadURL() {
    if (window.location.href.match("simlogin")) {
      this.AP.showHeaderAndSidebar = false;
    } else if (window.location.href.match("createautologin") || window.location.href.match("create-new-incident")) {
      this.AP.showHeaderAndSidebar = true;
    } else {
      this.router.navigate(["/authentication/signin"]);
    }
  }
  isLogggedIn() {
    // console.log('user logged in');
    const user = JSON.parse(localStorage.getItem("user"));
    if (user !== null) {
      this.router.navigate(["/home"]);
    }
  }
  onSsoLogin(): void {
    if (window.location.href.indexOf("adnh") != -1) {
      const adnh = "https://goaudits.xecurify.com/moas/broker/login/jwt/272506/adnhcompassme?client_id=t75gRPdKbd6cG5s8&redirect_uri=https://appservices.goaudits.com/webapp/api/auth/ssologinuser";
      this.posthogService.captureEvent("user triggered 'single sign on' so successfully", { Feature: "signin", Action: "single sign on" });
      window.open(adnh, "_self");

    } else {
      this.router.navigate(["/authentication/sso-login"]);
    }
  }
  onSignUp() {
    window.open(this.environment.portalUrl, '_blank')
  }
  googlesignin() {
    this.posthogService.captureEvent("user triggered trial account so successfully", { Feature: "signin", Action: "trial account" });
    window.open(this.environment.ssogogleurl, '_self')

  }

  microsignin() {
    window.open(this.environment.ssomicrourl, '_self')
    this.posthogService.captureEvent("user triggered 'microsoft sign in' so successfully", { Feature: "signin", Action: "microsoft sign in" });
  }
}
